import { createContext, useContext, useEffect, useState } from "react";
import { checkUserAuth } from "../services/user.service";
import useUserStore from "../store/useUserStore";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const storeInitialUser = useUserStore.getState()?.user || null;
    const [user, setUser] = useState(storeInitialUser);
    const [authChecked, setAuthChecked] = useState(false);
    const { setUser: setStoreUser, clearUser: clearStoreUser, setAuthChecked: setStoreAuthChecked } = useUserStore();

    const checkAuth = async () => {
        const token = localStorage.getItem("auth_token");
        try {
            const result = await checkUserAuth();
            if (result?.isAuthenticated && result.user) {
                setUser(result.user);
                setStoreUser(result.user); // Sync with store
            } else {
                const persistedUser = useUserStore.getState()?.user;
                if (token && persistedUser) {
                    setUser(persistedUser);
                } else if (!token) {
                    setUser(null);
                    clearStoreUser();
                }
            }
        } catch (err) {
            console.warn("Auth check status notice:", err?.message || err);
            const persistedUser = useUserStore.getState()?.user;
            if (token && persistedUser) {
                setUser(persistedUser);
            } else if (!token) {
                setUser(null);
                clearStoreUser();
            }
        } finally {
            setAuthChecked(true);
            setStoreAuthChecked(true); // Sync with store
        }
    };

    useEffect(() => {
        checkAuth(); // ✅ ONLY ONCE globally
    }, []);

    return (
        <AuthContext.Provider value={{ user, authChecked, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
